/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the QuotaSnapshot interface.
 */
export function instanceOfQuotaSnapshot(value) {
    if (!('limit' in value) || value['limit'] === undefined)
        return false;
    if (!('used' in value) || value['used'] === undefined)
        return false;
    return true;
}
export function QuotaSnapshotFromJSON(json) {
    return QuotaSnapshotFromJSONTyped(json, false);
}
export function QuotaSnapshotFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'limit': json['limit'],
        'used': json['used'],
    };
}
export function QuotaSnapshotToJSON(json) {
    return QuotaSnapshotToJSONTyped(json, false);
}
export function QuotaSnapshotToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'limit': value['limit'],
        'used': value['used'],
    };
}
